module.exports = __webpack_public_path__ + "static/media/脱出ゲーム.ec0450ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/脱出ゲーム.png
// module id = 323
// module chunks = 10